import { useEffect, type ReactNode } from 'react';

/**
 * Transient success feedback — the one "Saved." idiom. Render conditionally;
 * onDone fires after `duration` so the caller can clear its flag.
 */
export function Flash({
  children,
  onDone,
  duration = 4000,
}: {
  children: ReactNode;
  onDone?: () => void;
  duration?: number;
}) {
  useEffect(() => {
    if (!onDone) return;
    const t = window.setTimeout(onDone, duration);
    return () => window.clearTimeout(t);
  }, [onDone, duration]);

  return (
    <span role="status" aria-live="polite" className="text-sm text-success-300">
      {children}
    </span>
  );
}
